import AppBar from '@/agilis/components/AppBar/AppBar.vue'
import Configuration from '@/agilis/util/Configuration'
import UserNotificationBar from '@/agilis/components/UserNotificationBar/UserNotificationBar.vue'
import UserConfirm from '@/agilis/components/UserConfirm/UserConfirm.vue'
import TourLauncherMixin from '@/agilis/components/Tour/mixins/TourLauncherMixin'
import updateMixin from '@/agilis/components/App/mixins/update'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  mixins: [TourLauncherMixin, updateMixin],

  components: {
    AppBar,
    Configuration,
    UserNotificationBar,
    UserConfirm
  },

  data: () => ({
    userAuthenticated: false,
    userName: undefined,
    themeLoading: false
  }),

  created () {
    this.$store.dispatch('configurationStore/loadConfiguration')
      .then(() => {
        if (!this.$envmap.VUE_APP_AGILIS_KEYCLOAK_REQUIRED) {
          this.userName = this.$envmap.VUE_APP_AGILIS_USER_ID
          this.userAuthenticated = true
          this.loginCompleted()
        } else {
          this.userName = this.$keycloak.userName
          this.userAuthenticated = this.userName != null
          if (this.userAuthenticated) {
            this.loginCompleted()
          }
        }
        this.$router.agilis.manageRoute(this.$route)
      }).catch(err => {
        this.notifyError(err)
        this.themeLoading = false
      })
  },

  computed: {
    ...mapGetters({
      'configLoaded': 'configurationStore/configurationLoadingCompleted',
      userProfile: 'userDataStore/userProfile'
    }),

    loading () {
      return !this.configLoaded || !(this.userAuthenticated && this.userProfile?.id) || this.themeLoading
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    loginCompleted () {
      this.themeLoading = true
      // Utilizzo di Promise.all per avviare i dispatch contemporaneamente
      Promise.all([
        this.$store.dispatch('userDataStore/setUserId', this.userName),
        this.$store.dispatch('userActivityStore/initializeStore'),
        this.$store.dispatch('configurationStore/auth/setApplications'),
        this.$store.dispatch('configurationStore/auth/setWorkspaces'),
        this.$store.dispatch('configurationStore/auth/setTrackerTypes'),
        this.$store.dispatch('themeStore/changeTheme')
      ])
        .then(() => {
          this.$vuetify.theme.themes.light = this.$store.getters['themeStore/getPalette']
          this.$debug('Theme', this.$store.getters['themeStore/getTheme'])
          this.$debug('App created with configurator endpoint ' + this.$envmap.VUE_APP_AGILIS_CONFIGURATOR_ENDPOINT)
          this.$debug('Simulated user ', this.$store.state.userDataStore.userId)
          this.themeLoading = false
        })
        .catch(err => {
          this.notifyError(err)
          this.themeLoading = false
        })
      // this.$router.agilis.manageRoute(this.$route)
    },

    loadingTheme () {
      const theme = this.userProfile?.settings?.theme
      if (theme) {
        this.$store.dispatch('themeStore/changeTheme', theme)
        this.$vuetify.theme.themes.light = this.$store.getters['themeStore/getPalette']
      }
    }
  },

  watch: {
    $route (to) {
      this.$router.agilis.manageRoute(to)
    },

    userProfile (newValue) {
      if (newValue?.settings) {
        this.$vuetify.theme.dark = this.$store.getters['userDataStore/useDarkColors']
        this.loadingTheme()
      }
    },

    '$keycloak.userName' () {
      this.userName = this.$keycloak.userName
      this.userAuthenticated = this.userName != null
      if (this.userAuthenticated) {
        this.loginCompleted()
        this.$router.agilis.manageRoute(this.$route)
      }
    }
  }
}
